/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import styles from './Select.module.scss';
import { OptionType } from '../../types';
import Input from '../Input';

type Props = {
  value: string;
  onChange: (val: string) => void;
  options: OptionType[];
  placeholder?: string;
  space?: boolean;
}

const Select: React.FC<Props> = ({
  value,
  onChange,
  options,
  placeholder = '',
  space = true,
}) => {
  const [optionsShowing, setOptionsShowing] = useState<boolean>(false);
  const [selected, setSelected] = useState<OptionType | null>(null);
  useEffect(() => {
    if (value) {
      const exist = options.find((item) => item.value === value);
      setSelected(exist || null);
    }
  }, [value, options]);
  return (
    <div className={styles.select}>
      <Input
        value={selected ? selected.label : ''}
        placeholder={placeholder}
        onFocus={() => setOptionsShowing(true)}
        onBlur={() => setOptionsShowing(false)}
        space={space}
      />
      {
        optionsShowing
        && (
          <ul className={styles.options}>
            {
              options.map((item) => (
                <li
                  key={item.value}
                  className={styles.item}
                  onMouseDown={() => onChange(item.value)}
                >
                  {item.label}
                </li>
              ))
            }
          </ul>
        )
      }
    </div>
  );
};

export default Select;
